import React from 'react';

import { FormControlLabel } from '@material-ui/core';
import { updateAddPostVisibilityAction, updateManualVisibilityUpdateStatusAction } from 'actions/addPost';
import { connect } from 'react-redux';
import { selectVisibility } from 'selectors/addPost';
import styled from 'styled-components';
import { StyledTooltip, NewStyledIconButton } from 'styles/common';

import { POST_VISIBILITY_TYPES } from 'constants/ProjectConstants';
import { VisibilityIcon } from 'constants/icons';

export default function VisibilityComponent({
  visibility,
  changeIsVisibilityUpdatedByUserStatus,
  updateVisibility = null,
  size = 'tinierFixed',
  tooltip,
  // use two people team icon for GLOBAL visibility instead of globe icon
  useTeamIcon = false,
  ...iconProps
}) {
  // const [tooltipShown, setTooltipShown] = useState(
  //   Boolean(localStorage.getItem('postVisibilityTooltipShown') || false)
  // );

  function toggleVisibility() {
    if (!updateVisibility) {
      return;
    }
    // const isChecked = event.target.checked;
    const toggledVisibility =
      visibility === POST_VISIBILITY_TYPES.global.name
        ? POST_VISIBILITY_TYPES.private.name
        : POST_VISIBILITY_TYPES.global.name;
    updateVisibility(toggledVisibility);
    if (typeof changeIsVisibilityUpdatedByUserStatus === 'function') changeIsVisibilityUpdatedByUserStatus(true);
  }

  // function onTooltipOpen() {
  //   localStorage.setItem('postVisibilityTooltipShown', true);
  //   setTimeout(() => {
  //     setTooltipShown(true);
  //   }, 5000);
  // }

  return (
    <StyledTooltip
      // onOpen={onTooltipOpen}
      // title={

      //   tooltipShown
      //     ? ''
      //     : "Post's visibility: Do you want the post to visible to everyone or ony to those who are tagged?"
      // }
      title={tooltip || 'Click to toggle visibility'}
    >
      <NewStyledIconButton padding={size === 'tinierFixed' ? 'large' : 'xxLarge'} onClick={toggleVisibility}>
        <StyledVisibilityIcon
          visibility={visibility}
          size={size}
          color="textSecondary"
          useTeamIcon={useTeamIcon}
          {...iconProps}
        />
      </NewStyledIconButton>

      {/* <StyledFormControlLabel
        control={
          <Switch
            color="primary"
            checked={isChecked()}
            onChange={handleChange}
            name="addPostVisibility"
          />
        }
        label={
          isChecked()
            ? POST_VISIBILITY_TYPES.global.displayName
            : POST_VISIBILITY_TYPES.private.displayName
        }
        labelPlacement="start"
      /> */}
    </StyledTooltip>
  );
}

const StyledFormControlLabel = styled(FormControlLabel)`
  .MuiFormControlLabel-label {
    color: ${(props) => props.theme.palette.text.secondary};
  }
`;

const StyledVisibilityIcon = styled(VisibilityIcon)`
  vertical-align: middle;
  cursor: pointer;
`;

const mapStateToProps = (state, ownProps) => ({
  visibility: selectVisibility(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeIsVisibilityUpdatedByUserStatus() {
    dispatch(updateManualVisibilityUpdateStatusAction(true));
  },
  updateVisibility(visibility) {
    dispatch(updateAddPostVisibilityAction(visibility));
  },
});

export const VisibilityContainer = connect(mapStateToProps, mapDispatchToProps)(VisibilityComponent);
